import { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import './DeleteModal.css';

const VisibleToModal = ({ handleClose, show, employee, entity }) => {
    const showHideClassName = show
        ? 'delete-modal display-block'
        : 'delete-modal display-none';

    const [employeeStr, setEmployeeStr] = useState('');
    const [entityStr, setEntityStr] = useState('');

    useEffect(() => {
        const splitIntoArray = () => {
            if (employee && entity) {
                setEmployeeStr(employee.join(', '));
                setEntityStr(entity.join(', '));
            }
        };

        splitIntoArray();
    }, [employee, entity]);

    return (
        <div className={showHideClassName}>
            <section className='delete-modal-main'>
                <Row>
                    <Col>
                        <h4 className='modal-title'>Visible To</h4>
                        <p style={{ textTransform: 'capitalize' }}>
                            Employee Types: {employeeStr}
                        </p>
                        <p>Entities: {entityStr}</p>
                        <Button
                            variant='outline-secondary'
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                    </Col>
                </Row>
            </section>
        </div>
    );
};

export default VisibleToModal;
